<template>
  <div>
    <div>
      <!-- <home-adv></home-adv> -->
    </div>
    <div class="footer-container">
      <div class="footer-main">
        <div class="footer-top">
          <div class="com-logo">
            <img src="../assets/images/logo-long.png" alt />
          </div>
          <div class="com-info">
            <div class="platform-rules">
              <div class="title fontw">
                平台规则
              </div>
              <ul>
                <li>
                  <a @click="registerAgreement">用户注册协议</a>
                </li>
                <li>
                  <router-link
                    :to="{ path: '/statement', query: { f: '平台隐私声明' } }"
                    target="_blank"
                  >
                    平台隐私声明
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{ path: '/statement', query: { f: '平台免责声明' } }"
                    target="_blank"
                  >
                    平台免责声明
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="platform-rules">
              <div class="title fontw">
                会员服务
              </div>
              <ul>
                <li>
                  <a href="javascript:void(0);" @click="register">会员注册</a>
                </li>
                <li>
                  <router-link to="/enterpriseRights" target="_blank">
                    会员权益
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="platform-rules">
              <div class="title fontw">
                平台介绍
              </div>
              <ul>
                <li>
                  <router-link
                    to="/informationBase?informationListGuid=about_lib"
                    target="_blank"
                  >
                    关于我们
                  </router-link>
                </li>
                <li>
                  <router-link
                    :to="{
                      path: '/helpCenter',
                      query: { judgeKey: '帮助中心' }
                    }"
                    target="_blank"
                  >
                    帮助中心
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="contact">
              <p class="label fontw">
                咨询电话：
              </p>
              <p class="value">
                021-31579633
              </p>
              <p class="label fontw">
                邮箱：
              </p>
              <p class="value">
                service@aiot369.com
              </p>
            </div>
          </div>
          <div class="qrcode-list">
            <div class="qrcode">
              <div class="img">
                <img
                  src="../assets/images/homePage/wx_offical_account.jpg"
                  alt
                />
              </div>
              <p>微信公众号</p>
            </div>
            <!-- <div class="qrcode">
              <div class="img">
                <img src="../../assets/images/homePage/App.jpg" alt />
              </div>
              <p>
                使用手机浏览器
              </p>
              <p>扫码下载App</p>
            </div> -->
            <div class="qrcode">
              <div class="img">
                <img src="../assets/images/homePage/minipro.jpg" alt />
              </div>
              <p>
                微信小程序
              </p>
            </div>
          </div>
        </div>
        <div class="copyright">
          <p class="friendship-link">
            友情链接：
            <a href="http://www.gov.cn/" target="_blank">中国政府网</a>
            <span class="line"></span>
            <a href="http://www.ganggouyc.com/" target="_blank">钢构英才网</a>
            <span class="line"></span>
            <a href="https://www.mysteel.com/" target="_blank">我的钢铁网</a>
            <span class="line"></span>
            <a href="http://www.zhaogang.com/" target="_blank">找钢网</a>
            <span class="line"></span>
            <a href="http://www.cscscn.cn/" target="_blank">钢构产业网 </a>
            <span class="line"></span>
            <a href="http://www.xdjzcyw.com/" target="_blank">
              现代建筑产业网
            </a>
            <span class="line"></span>
            <a href="http://www.crcc.cn/" target="_blank">中国铁建 </a>
            <span class="line"></span>
            <a href="https://www.cscec.com.cn/" target="_blank">中建集团 </a>
            <span class="line"></span>
            <a href="https://www.ccccltd.cn/" target="_blank">中国交建 </a>
            <span class="line"></span>
            <a href="https://www.scg.com.cn/" target="_blank">上海建工 </a>
          </p>
          <p>
            &copy; Copyright 2019-2020&nbsp; 上海西兰蒂亚科技有限公司&nbsp;
            版权所有 沪ICP备19042151号-3&nbsp;
            <span id="cnzz_stat_icon_1279126836" class="cnzz">
              <a
                href="https://www.cnzz.com/stat/website.php?web_id=1279126836"
                target="_blank"
                title="站长统计"
              >
                <img
                  border="0"
                  hspace="0"
                  vspace="0"
                  src="https://icon.cnzz.com/img/pic.gif"
                />
              </a>
            </span>
          </p>
          <div class="footer-beian">
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502016251"
              style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
            >
              <img
                src="../assets/images/homePage/guohui.png"
                style="float:left;"
              />
              <p
                style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"
              >
                沪公网安备 31011502016251号
              </p>
            </a>
            <a
              class="network-report"
              href="https://www.12377.cn/"
              target="_blank"
            >
              <img src="../assets/images/homePage/network-report.png" alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeFooter',
  data() {
    return {}
  },
  methods: {
    register() {
      let toHref = `${process.env.VUE_APP_SHOP_WEBSITE}/register`
      window.location.href = toHref
    },
    // 会员注册协议
    registerAgreement() {
      let href = `${process.env.VUE_APP_SHOP_WEBSITE}/article-agreement?type=0`
      window.open(href)
    }
  }
}
</script>

<style lang="scss" scoped>
.cnzz {
  display: inline-block;
  img {
    max-width: 100px;
  }
}
.footer-container {
  width: 100%;
  height: 340px;
  background: #333333;
  .fontw {
    font-weight: bold;
  }
  .footer-main {
    width: 1200px;
    margin: 0 auto;
    .footer-top {
      padding-top: 37px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .com-logo {
        width: 146px;
        height: 49px;
        margin-right: 125px;
        margin-left: 10px;
        img {
          width: 100%;
        }
      }
      .com-info {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 20px;
        .platform-rules {
          margin-right: 61px;
          .title {
            font-size: 15px;
            color: #fff9f9;
            line-height: 15px;
          }
          ul {
            li {
              margin-top: 20px;
              font-size: 14px;
              color: #a9a9a9;
              a {
                color: #a9a9a9;
                cursor: pointer;
              }
              &:hover {
                a {
                  color: #ffffff;
                }
              }
            }
            li:first-child {
              margin-top: 30px;
            }
          }
        }
        .contact {
          margin-right: 100px;
          .label {
            font-size: 15px;
            color: #fff9f9;
            line-height: 15px;
          }
          .value {
            margin: 22px 0 30px 0;
            font-size: 14px;
            color: #a9a9a9;
            line-height: 14px;
            :last-child {
              margin-bottom: 0;
            }
          }
        }
      }
      .qrcode-list {
        display: flex;
        justify-content: flex-start;
        .qrcode {
          width: 100px;
          .img {
            width: 100px;
            height: 100px;
            border: 1px solid #ffffff;
            img {
              width: 100%;
            }
          }
          p {
            width: 100px;
            font-size: 12px;
            color: #ffffff;
            text-align: center;
            white-space: nowrap;
            margin-top: 16px;
            &:nth-child(3) {
              margin-top: 2px;
            }
          }
        }
        :first-child {
          margin-right: 40px;
        }
        :last-child {
          margin-right: 18px;
        }
      }
    }

    .copyright {
      width: 100%;
      font-size: 12px;
      text-align: center;
      color: #fffafa;

      .friendship-link {
        line-height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        .line {
          display: inline-block;
          width: 1px;
          height: 13px;
          background: #fffafa;
          margin: 0 10px;
        }
        a:hover {
          text-decoration: underline;
          text-underline-offset: 2px;
        }
      }
      a {
        color: #fffafa;
      }
    }
    .footer-beian {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 300px;
      margin: 0 auto;
      padding: 20px 0 0;
      a {
        color: red;
        img {
          width: auto;
          height: auto;
        }
      }
      .network-report {
        display: inline-block;
        position: relative;
        width: 100px;
        height: 10px;
        img {
          position: absolute;
          right: -15px;
          top: -15px;
          max-width: 100px;
          max-width: 100px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
